import React, { useState } from 'react'
import { checkTextTranslation, checkTranslation, imageAddress, translate } from '../../utils/useful';
import ButtonAnimated from '../buttons/ButtonAnimated';
import MessageStatusView from '../views/messenger/boxes/MessageStatusView';
import HttpServices from '../../utils/Http.services';
// import NotifRequestBox from './NotifConnectionRequestBox';
import NotifInvitationRequestBox from './NotifInvitationRequestBox';
import NotifConnectionRequestBox from './NotifConnectionRequestBox';
import NotifSystemBox from './NotifSystemBox';

const NotifBox = props => {

    const [exit, setExit] = useState(false)
    const [width, setWidth] = useState(0)
    const [intervalId, setIntervalId] = useState(null)
    const [isLoadingHandle, setIsLoadingHandle] = useState(null)




    React.useEffect(() => {
        startTimer()
    }, [])

    React.useEffect(() => {
        if (width >= 100) {
            console.log()
            closeNotif()
        }
    }, [width])


    const startTimer = () => {
        const id = setInterval(() => {
            setWidth((prevWidth) => {
                if (prevWidth < 100) {
                    return prevWidth + 0.5
                }
                clearInterval(id)
                // console.log(prevWidth)
                // closeNotif()
                return prevWidth
            })
        }, 20);

        setIntervalId(id)
    }

    const pauseTimer = () => {
        clearInterval(intervalId)
    }

    const closeNotif = () => {
        pauseTimer()
        setExit(true)
        setTimeout(() => {
            // console.log("CLOSE NOTIF")
            props.removeNotif(props.id)
        }, 500);
    }

    const addNewWindow = (path) => {

        props.addNewWindow("hub", { path: path, type: 'applet' }, "center")
    }

    const renderNotif = () => {

        if (props?.notif?.type == 'request') {
            // onMouseLeave={() => startTimer()}
            return (

                <div onMouseOver={() => pauseTimer()} onMouseLeave={() => startTimer()} className={'mb-2 notifBox w-100 ' + (props?.type) + ' ' + (exit ? 'rightHide' : '')}>
                    {props?.notif.topic == 'invitation' && (
                        <NotifInvitationRequestBox data={props.notif} isPopupMessange={true} addNewWindow={props.addNewWindow} />
                    )}
                    {props?.notif.topic?.startsWith('connection-') && (
                        // Relation connection requests
                        <NotifConnectionRequestBox data={props.notif} isPopupMessange={true} addNewWindow={props.addNewWindow} />
                    )}
                    <div style={{ width: width + '%', backgroundColor: '#aaaaaa50', height: 3, borderRadius: 10 }} >

                    </div>
                </div>

            )
        } else if (props?.notif?.type == 'system') {
            return (

                <div onMouseOver={() => pauseTimer()} onMouseLeave={() => startTimer()} className={'mb-2 notifBox ' + (props?.type) + ' ' + (exit ? 'rightHide' : '')}>

                    <NotifSystemBox data={props.notif} isPopupMessange={true} addNewWindow={props.addNewWindow} />

                    <div style={{ width: width + '%', backgroundColor: '#aaaaaa50', height: 3, borderRadius: 10 }} >

                    </div>
                </div>

            )
        } else if (props?.notif?.type == 'automation') {
            return (

                <div onMouseOver={() => pauseTimer()} onMouseLeave={() => startTimer()} className={'mb-2 notifBox ' + (props?.type) + ' ' + (exit ? 'rightHide' : '')}>
                    <div className='py-2 px-2'>
                        <div className=''>
                            <div className='flexc mrd-2'>
                                <div className='flexcc mrd-1'>
                                    <img src={imageAddress(props?.notif?.appletHub?.image, 'profile', 'thumb')} height={26} width={26} className='br-20' alt='' />
                                </div>
                                <div className='flexcc'>
                                    <img src={'/assets/icons/useful/bot.svg'} height={24} width={24} className='' alt='' />
                                </div>
                            </div>

                            <div className='mt-1'>
                                {/* <p className="font-size-12">{checkTextTranslation(props?.notif?.frame?.name)} - {checkTextTranslation(props?.notif?.applet?.name)}</p> */}
                                <p className="font-size-14 text-semibold">{props?.notif?.appletHub?.fullname}</p>
                            </div>
                        </div>

                        <div className=' mb-2 mt-1'>
                            {props?.notif?.title && (<p className="notifTitle text-semibold">{checkTextTranslation(props?.notif?.title)}</p>)}
                            {props?.notif?.message && (
                                // <p className="notifDescription">{props?.notif?.message}</p>
                                <div className='font-size-12 mt-1' dangerouslySetInnerHTML={{ __html: props?.notif?.message }} />
                            )}

                        </div>
                    </div>

                    <div style={{ width: width + '%', backgroundColor: '#aaaaaa50', height: 3, borderRadius: 10 }} >

                    </div>
                </div>

            )
        } else {
            
            let notif = props.notif
            return (
                <div onMouseOver={() => pauseTimer()}  onMouseLeave={() => startTimer()} className={'mb-2 notifBox ' + (props?.type) + ' ' + (exit ? 'rightHide' : '')}>
                    <div className="py-2 px-2">
                        <div>
                            <div className='flexc'>
                                <div className='flexcc mrd-2'>
                                    <img src={imageAddress(notif?.appletHub?.image, 'profile', 'thumb')} height={26} width={26} className='br-20' alt='' />
                                    {/* <img src={'/assets/icons/useful/user.png'} height={30} width={30} className='br-20' alt='' /> */}
                                </div>

                                <div>
                                    {notif?.frame ? (
                                        <p className="font-size-12">{checkTextTranslation(notif?.frame?.name)} - {checkTextTranslation(notif?.applet?.name)}</p>
                                    ) : (
                                        <p className="font-size-12">{checkTextTranslation(notif?.applet?.name)}</p>
                                    )}
                                    <p className="font-size-12">{notif?.appletHub?.fullname}</p>
                                </div>
                            </div>
                            <div className='mt-1 mb-2'>

                                {notif?.title && (<p className="notifTitle text-semibold">{checkTextTranslation(notif?.title)}</p>)}
                                {notif?.description && (<p className="notifDescription">{checkTextTranslation(notif?.description)}</p>)}
                                {notif?.message && (<p className="notifDescription">{checkTextTranslation(notif?.message)}</p>)}

                            </div>
                            <div className='flexce'>
                                <ButtonAnimated
                                    iconwidth='24px'
                                    icon='/assets/icons/arrow-right-white.svg'
                                    onClick={() => { addNewWindow([notif?.appletHub?.username, notif?.applet.slug, 'admin', notif?.frame._id]) }}
                                    // isLoading={this.state.isLoadingData}
                                    title={translate('View')}
                                    textColor={'#fff'}
                                    bg={'linear-gradient(90deg, #5856D6, #7D7AFF)'}
                                // width={'100%'}
                                />
                            </div>
                        </div>
                    </div>
                    <div style={{ width: width + '%', backgroundColor: '#aaaaaa50', height: 3, borderRadius: 10 }} >

                    </div>
                </div>
            )
        }
    }


   const translateStatus = (status) => {
        let newStatus
        switch (status) {
            case 0:
                newStatus = 'not active'
                break;

            case 1:
                newStatus = 'pending'
                break;

            case 2:
                newStatus = 'waiting for awnser'
                break;

            case 3:
                newStatus = 'awnsered'
                break;

            case 4:
                newStatus = 'done'
                break;

            default:
                break;
        }
        return newStatus
    }


    const renderMessage = (messenger, message, myId) => {

        let text = message?.text

        return (
            <div className="  flexc w-100 " style={{ maxHeight: 200, }} >

                <div className='w-100 flexc' style={{ alignItems: 'flex-start' }} >

                    <div className="flexc w-100 ">
                        {message?.sender == myId && (
                            <div className="mrd-1">
                                <MessageStatusView status={message?.status} colors={this.props?.colors} />
                            </div>
                        )}
                        {(text && !message?.file) && (message?.trashed == false) ? (
                            <>

                                <p className="" style={{ color: '#000', fontSize: 12, }}>{checkTranslation(text)}</p>

                            </>
                        ) : (
                            <div>
                                {message?.trashed == true ? (
                                    <p className="w-100" style={{ color: '#777', fontSize: 10, textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap", maxWidth: "140px" }}>{translate('messenger.This message was deleted')}</p>
                                ) : (
                                    <>
                                        {message?.voice && (
                                            <div className="flexcc">
                                                <img className="mrd-1" src={'/assets/icons/messenger/mic-gray.svg'} height={18} />
                                                <p className="" style={{ color: '#777', fontSize: 12 }}>{translate('messenger.Voice')}</p>
                                            </div>
                                        )}
                                        {message?.file && (
                                            <div className="flexcc">
                                                <img className="mrd-1" src={'/assets/icons/messenger/doc-gray.svg'} height={18} />
                                                <p className="" style={{ color: '#777', fontSize: 12 }}>{translate('messenger.File')}</p>
                                            </div>
                                        )}
                                        {message?.video && (
                                            <div className="flexcc">
                                                <img className="mrd-1" src={'/assets/icons/messenger/play-gray.svg'} height={18} />
                                                <p className="" style={{ color: '#777', fontSize: 12 }}>{translate('messenger.Video')}</p>
                                            </div>
                                        )}
                                        {message?.image && (
                                            <div className="flexcc">
                                                <img className="mrd-1" src={'/assets/icons/messenger/pic-gray.svg'} height={18} />
                                                <p className="" style={{ color: '#777', fontSize: 12 }}>{translate('messenger.Image')}</p>
                                            </div>
                                        )}
                                        {/* {message?.systemInfo && (
                                                <div className="flexcc">
                                                    <img className="mrd-1" src={'/assets/icons/messenger/systeminfo.svg'} height={18} />
                                                    <p className="" style={{ color: '#777', fontSize: 12, maxWidth: '140px', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', }}>{checkTranslation(systemInfo)}</p>
                                                </div>
                                            )} */}
                                    </>
                                )}
                            </div>
                        )}
                    </div>


                    {/* {messenger.type == 'support' && (
                        <>
                            {message?.assignee &&
                                <div className="flexc">
                                    <p className="font-size-12 main-c2 weight-400">{translate('Assignee')}:&nbsp;</p>
                                    <p className="font-size-12 main-c2 weight-500">{message?.assignee?.hub?.fullname}</p>
                                </div>
                            }
                            <div className="flexc">
                                <p className="font-size-12 main-c2 weight-400">{translate('Status')} :&nbsp;</p>
                                <p className="font-size-12 main-c2 weight-500">{translateStatus(message?.status)}</p>
                            </div>
                        </>

                    )} */}

                </div>
            </div>
        )
    }


    if (props?.type == 'notif') {
        return (

            renderNotif()
        )
    } if (props?.type == 'message') {
        return (

            <div onMouseOver={() => pauseTimer()} onMouseLeave={() => startTimer()} className={'mb-2 notifBox w-100 ' + (props?.type) + ' ' + (exit ? 'rightHide' : '')}>
                <div className="py-2 px-2 w-100">
                    <div className='w-100'>
                        <div className='flexc w-100'>
                            <div className='flexcc mrd-2'>
                                <img src={imageAddress(props?.image, 'profile', 'thumb')} height={26} width={26} className='br-20' alt='' />
                                {/* <img src={'/assets/icons/useful/user.png'} height={30} width={30} className='br-20' alt='' /> */}
                            </div>

                            <div>
                                <p className="font-size-12">{checkTextTranslation(props?.name)} {props?.applet ? ("-" + checkTextTranslation(props?.applet?.name)) : ""}</p>
                                {props?.appletHub?.name && (
                                    <p className="font-size-12">{props?.appletHub?.name}</p>
                                )}
                            </div>
                        </div>
                        <div className='mt-1 mb-2' >
                            {props?.title && (<p className="notifTitle text-semibold" style={{ marginBottom: 1 }}>{checkTranslation(props?.title)}</p>)}
                            {props?.message && (renderMessage(props.messenger, props.message, props.messengersHub))}
                        </div>

                        <div className='flexce mt-1' >
                            <ButtonAnimated
                                iconwidth='24px'
                                icon='/assets/icons/arrow-right-white.svg'
                                onClick={() => { addNewWindow([props?.appletHub?.username, props?.applet.slug, 'admin', props?.frame._id]) }}
                                // isLoading={this.state.isLoadingData}
                                title={translate('View')}
                                textColor={'#fff'}
                                bg={'linear-gradient(90deg, #5856D6, #7D7AFF)'}
                            // width={'100%'}
                            />
                        </div>
                    </div>
                </div>
                <div style={{ width: width + '%', backgroundColor: '#aaaaaa50', height: 3, borderRadius: 10 }} >

                </div>
            </div>
        )
    } else {
        return (
            <div onMouseOver={() => pauseTimer()} onMouseLeave={() => startTimer()} className={'mb-2 notifBox ' + (props?.type) + ' ' + (exit ? 'rightHide' : '')}>
                <div className="py-2 px-3">
                    {props?.title && (<p className="notifTitle">{checkTextTranslation(props?.title)}</p>)}
                    {props?.description && (<p className="notifDescription">{checkTextTranslation(props?.description)}</p>)}
                </div>
                <div style={{ width: width + '%', backgroundColor: '#eeeeee50', height: 3, borderRadius: 10 }} >

                </div>
            </div>

        )

    }

}

export default NotifBox
